<template lang="pug">
.ad-data-container(@click="expand = !expand")
  .ad-data
    .ad-id
      span.material-symbols-outlined file_copy
      span.tag {{ data.articleDefault }}

    .ad-article.capitalize(v-if="!history") {{ data.article }}

    .ad-person.capitalize(v-if="!history") {{ data.person }}

    .ad-design.capitalize(v-if="!history") {{ data.design }}

    .ad-transaction(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}

    .ad-date(v-if="history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

  transition(name="slide-fade")
    shForm.list-ad(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")

  transition(name="slide-fade")
    shHistory.list-ad(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'ArticleDefault',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.ad-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.ad-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis 100%
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.ad-id
  display flex
  align-items center
  gap .5em

.list-ad
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .ad-data
    column-gap 0
    row-gap 1em

  .ad-id
    width 20em
  .ad-article
    width 8em
  .ad-person
    width 6em
  .ad-design
    width 8em
  .ad-transaction
    width 8em
  .ad-date
    width 10em
</style>



// WEBPACK FOOTER //
// src/components/pages/articleDefault/ArticleDefault.vue